export const groupBy = <T>(
  array: T[],
  predicate: (value: T, index: number, array: T[]) => string,
): Map<string, T[]> => {
  const map = new Map<string, T[]>();
  array.forEach((item, index) => {
    const key = predicate(item, index, array);
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key)?.push(item);
  });
  return map;
};

export const createChunks = <T>(array: T[], chunkSize: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0, j = 0; i < array.length; i += chunkSize, j++) {
    chunks[j] = array.slice(i, i + chunkSize);
  }
  return chunks;
};
